import * as feldm from '~/app/tracking/feld-m-types';

export enum EventAction {
	PageLoad = 'page_load',
	NonInteraction = 'non_interaction',
	Callback = 'callback',
	Download = 'download',
	Content = 'content',
	InternalLink = 'internal_link',
	Impression = 'impression',
	ViewChange = 'view_change',
	Image = 'image',
	ExitLink = 'exit_link',
}

export enum NbaTargetTypes {
	ConfigurationSave = 'configuration save',
	PDF = 'pdf',
	GenericLink = 'generic link',
	Contact = 'contact',
	ConfigurationLoad = 'configuration load',
	CarCompare = 'car compare',
	GoToVTP = 'go to vtp',
	ImageDownload = 'image download',
	WalletDownload = 'wallet download',
	PoaLink = 'poa link',
	TestDrive = 'testdrive',
	RequestTradeInAppraisal = 'request a trade-in appraisal',
	BuyWallbox = 'buy wallbox',
	FinancialServices = 'financial services',
}

export type AdditionalObjects = {
	componentInfo: {
		componentID: number;
	};
	attributes: {
		implementer: number;
		version: string;
		priceChange?: string;
		totalPrice?: string;
		solutionGroup?: { name: string }[];
	};
	page?: {
		pageInfo?: {
			pageID?: string;
		};
	};
};

export type RelatedProducts = {
	addedItems: {
		carParts: CarPart[];
		packages: Package[];
	};
	removedItems: {
		carParts: CarPart[];
		packages: Package[];
	};
	displayedItems?: {
		packages: Package[];
		carParts: CarPart[];
	};
};

export type BuyableVehicle = {
	buyableVehicle: {
		productInfo: {
			productID: string;
			productName: string;
			manufacturer?: 'Audi';
		};
		category: {
			primaryCategory?: string;
			subCategory1: string;
			productType: string;
		};
		price: {
			totalPrice: string;
		};
	};
};

export type BoolString = 'true' | 'false';

export type EventInfo = {
	eventAction: EventAction;
	eventName: string;
};

export type EventAttributes = {
	componentName: string;
	label: string;
	targetURL: string;
	clickID: string;
	elementName: string;
	value: string;
	pos: string;
	actionType?: string;
	wall?: { elementName: string };
	currentPage?: string;
	clickedCTA?: { id: string; label: string; destination: string };
	clickedLinkType?: 'button text with icon' | 'button primary' | 'button secondary';
	relatedProducts?: RelatedProducts | BuyableVehicle;
	relatedElements?: {
		elementName: string;
		elementValue: string;
		elementCurrentStep?: string;
		elementTotalSteps?: string;
	}[];
	relatedFilters?: {
		id: string;
		values: string[];
	}[];

	relatedIncentive?: feldm.ProductDataConfiguredVehicle['incentives'];
};

export type DataLayerEvent = {
	eventInfo: EventInfo;
	attributes: EventAttributes;
};

export type CarPart = {
	productInfo: {
		productID: string;
		productName: string;
		manufacturer: 'Audi';
	};
	category: {
		primaryCategory: string;
		productType: 'car part' | 'package';
	};
	price: {
		price: string;
	};
	attributes: {
		prString7: string;
		familyID: string;
		familyName: string;
		groupID: string;
		groupName: string;
		isPreSelected: BoolString | '';
		isStandardEquipment: BoolString;
		selectionType?: 'manual' | 'automatic';
	};
};

export type Package = CarPart & {
	carParts: CarPart[];
};

export type ProductDataConfiguredVehicle = {
	productInfo: {
		productID: string;
		productName: string;
		manufacturer: 'Audi';
		configurationID: object;
		configurationHash: string;
	};
	category: {
		primaryCategory: string;
		subCategory1: string;
		productType: 'configured car';
	};
	price: {
		totalPrice: string;
		modelPrice: string;
		optionsPrice: string;
		rateTotalPrice: string;
		currency: string;
	};
	financing?: {
		financingName: string;
		mileage: string;
		duration: string;
		downPayment: string;
	};
	attributes: {
		modelLine: string;
		modelYear: string;
		bodyType: string;
		engine: string;
		audiCode: string;
		isSaved: BoolString;
		configurationStartTime: string;
		entryType: 'default' | 'audicode' | 'pr string';
	};
	carParts: CarPart[];
	packages: Package[];
	incentives: {
		id: string;
		title: string;
		value: string;
		targetGroup: string;
		discountSelected: boolean;
		type: 'static' | 'dynamic';
		relatedSelection: 'engine';
	}[];
};

export type ProductData = {
	configuredVehicle: ProductDataConfiguredVehicle[];
};

export type TrackPayload = {
	event: DataLayerEvent;
	additionalObjects?: AdditionalObjects;
};

export type PageUpdateObject = {
	page?: {
		pageInfo?: {
			destinationURL?: string;
			referringURL?: string;
		};
	};
};
